import instanceAxios from '../config/api'
import {
  ActionCountsByStatus,
  ActionsBySourceCategory,
  calculateActionProgressBySourceType,
  calculateProjectBudgetPercentageType,
  CountActionsBySCFResponse,
  countSecurityCheckFamilyByProjectType,
  CoursRatio,
  CriticalRatio,
  DoneRatio,
  getActionsBudgetTableType,
  groupActionsBySecurityCheckFamilyType,
  HighRatio,
  InProgressCriticalHighActionRatio,
  LowRatio,
  MediumRatio,
  Percentage,
  Projet,
  projetOverdueProgressCritical,
  ProjetPriority,
  ProjetRes,
  ProjetRes1,
  ProjetResponse,
  ProjetType,
} from '../types/projetTypes'
const API_URL = '/projets'

export const getAllProjets = async ({
  page,
  pageSize,
  search,
}: {
  page?: number
  pageSize?: number
  search?: string
}) => {
  try {
    const response = await instanceAxios.get<ProjetResponse>(`${API_URL}`, {
      params: {
        page,
        pageSize,
        search,
      },
    })
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch Projet.')
  }
}
export const deleteProjetApi = async (ProjetId: string) => {
  try {
    const response = await instanceAxios.delete<Projet[]>(
      `${API_URL}/` + ProjetId
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch Projets.')
  }
}

export const addProjetApi = async (newProjet: Projet): Promise<Projet> => {
  try {
    const response = await instanceAxios.post<Projet>(`${API_URL}`, newProjet)
    console.log(response.data)
    return response.data
  } catch (error: any) {
    throw new Error(error?.response?.data?.message || 'Failed to add Projet.')
  }
}

export const getProjetbyIdApi = async (ProjetId: string) => {
  try {
    const response = await instanceAxios.get<Projet>(`${API_URL}/` + ProjetId)
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetchProjet.')
  }
}

export const updateProjetApi = async (
  updateProjet: Projet,
  _id: string
): Promise<Projet> => {
  try {
    const response = await instanceAxios.put<Projet>(
      `${API_URL}/${_id}`,
      updateProjet
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to PUTProjet.')
  }
}

export const getProjetbyPipelineApi = async (PipelineId: string) => {
  try {
    const response = await instanceAxios.get<ProjetRes1>(
      `pipelines/getProjets/` + PipelineId
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetchProjets.')
  }
}
export const getProjetbyMissionApi = async (
  MissionId: string,
  page?: number,
  pageSize?: number
) => {
  try {
    const response = await instanceAxios.get<ProjetResponse>(
      `missions/getProjets/${MissionId}`,
      {
        params: {
          ...(page !== undefined && { page }),
          ...(pageSize !== undefined && { pageSize }),
        },
      }
    )

    console.log(response.data)
    return response.data
  } catch (error) {
    console.error('Failed to fetch Projects:', error)
    throw new Error('Failed to fetch Projects.')
  }
}

export const addProjetToPipelineApi = async (
  ProjetId: string[],
  id: string
): Promise<Projet[]> => {
  try {
    const response = await instanceAxios.put<Projet[]>(
      `pipelines/addProjets/${id}`,
      ProjetId
    )

    console.log(response.data)
    return response.data
  } catch (error) {
    console.log(error)
    throw new Error('Failed to PUT Project.')
  }
}

export const removeProjetFromPipelineApi = async (
  projets: ProjetType,
  _id: string
): Promise<Projet[]> => {
  try {
    const response = await instanceAxios.put<Projet[]>(
      `pipelines/removeProjets/${_id}`,
      projets
    )
    return response.data
  } catch (error) {
    console.log(error)
    throw new Error('Failed to PUT Pipeline.')
  }
}

export const countActionsStatusByProjetIdApi = async (
  idProjet: string,
  status?: string
): Promise<ProjetResponse> => {
  try {
    const response = await instanceAxios.get<ProjetResponse>(
      `projets/countActionsStatus/${idProjet}`,
      {
        params: { status },
      }
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch action count by project ID.')
  }
}

export const getActionStatusCoursRatioApi = async (
  idProjet: string
): Promise<CoursRatio> => {
  try {
    const response = await instanceAxios.get<ProjetResponse>(
      `projets/actionStatusCoursRatio/${idProjet}`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch action Ratio')
  }
}

export const getActionStatusDoneRatioApi = async (
  idProjet: string
): Promise<DoneRatio> => {
  try {
    const response = await instanceAxios.get<ProjetResponse>(
      `projets/actionStatusDoneRatio/${idProjet}`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch task Status DoneRatio')
  }
}

export const getOverdueInProgressActionRatioApi = async (
  idProjet: string
): Promise<InProgressCriticalHighActionRatio> => {
  try {
    const response = await instanceAxios.get<ProjetResponse>(
      `projets/overdueInProgressActionRatio/${idProjet}`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch  OverdueInProgress task')
  }
}

export const countActionsPriorityByProjetIdApi = async (
  idProjet: string,
  priority?: number
): Promise<ProjetPriority> => {
  try {
    const response = await instanceAxios.get<ProjetPriority>(
      `projets/actionCountsByPriority/${idProjet}`,
      {
        params: { priority },
      }
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch action count by project ID BY Priority.')
  }
}

export const getActionPriorityCriticalRatioApi = async (
  idProjet: string
): Promise<CriticalRatio> => {
  try {
    const response = await instanceAxios.get<CriticalRatio>(
      `projets/actionPriorityCriticalRatio/${idProjet}`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch  Priority Critical task')
  }
}

export const getActionPriorityHighRatioApi = async (
  idProjet: string
): Promise<HighRatio> => {
  try {
    const response = await instanceAxios.get<ProjetResponse>(
      `projets/actionPriorityHighRatio/${idProjet}`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to Count Priority High Ratio')
  }
}

export const getActionPriorityMediumRatioApi = async (
  idProjet: string
): Promise<MediumRatio> => {
  try {
    const response = await instanceAxios.get<ProjetResponse>(
      `projets/actionPriorityMediumRatio/${idProjet}`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to Count Priority Medium Ratio')
  }
}

export const getActionPriorityLowRatioApi = async (
  idProjet: string
): Promise<LowRatio> => {
  try {
    const response = await instanceAxios.get<ProjetResponse>(
      `projets/actionPriorityLowRatio/${idProjet}`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to Count Priority Low Ratio')
  }
}

export const getOverdueInProgressCriticalHighActionRatioApi = async (
  idProjet: string
): Promise<projetOverdueProgressCritical> => {
  try {
    const response = await instanceAxios.get<projetOverdueProgressCritical>(
      `projets/overdueInProgressCriticalHighActionRatio/${idProjet}`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to Count overdue  InProgress Critical HighRatio')
  }
}

export const countActionsBySourceCategoryApi = async (
  idProjet: string
): Promise<ActionsBySourceCategory> => {
  try {
    const response = await instanceAxios.get<ActionsBySourceCategory>(
      `projets/actionCountsBySourceCategory/${idProjet}`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to Count Actions BySourceCategory ')
  }
}

export const actionCountsByStatusApi = async (
  idProjet: string
): Promise<ActionCountsByStatus> => {
  try {
    const response = await instanceAxios.get<ActionCountsByStatus>(
      `projets/actionCountsByStatus/${idProjet}`
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to Count actionCountsByStatus ')
  }
}

export const actionCountsByTypeAndStatusApi = async (
  idProjet: string
): Promise<ActionCountsByStatus> => {
  try {
    const response = await instanceAxios.get<ActionCountsByStatus>(
      `projets/actionCountsByTypeAndStatus/${idProjet}`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to Count actionCountsByTypeAndStatus ')
  }
}

export const calculateProjectBudgetPercentageApi = async (
  idProjet: string
): Promise<calculateProjectBudgetPercentageType> => {
  try {
    const response =
      await instanceAxios.get<calculateProjectBudgetPercentageType>(
        `projets/calculateProjectBudgetPercentage/${idProjet}`
      )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to calculate Project Budget Percentage')
  }
}

export const getActionsBudgetTableApi = async (
  idProjet: string
): Promise<getActionsBudgetTableType> => {
  try {
    const response = await instanceAxios.get<getActionsBudgetTableType>(
      `projets/getActionsBudgetTable/${idProjet}`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to Countcalculate Project Budget Percentage')
  }
}

export const calculateActionProgressBySourceApi = async (
  idProjet: string
): Promise<calculateActionProgressBySourceType> => {
  try {
    const response =
      await instanceAxios.get<calculateActionProgressBySourceType>(
        `projets/calculateActionProgressBySource/${idProjet}`
      )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to Countcalculate action Progress By Source')
  }
}

export const groupActionsBySecurityCheckFamilyApi = async (
  idProjet: string
): Promise<groupActionsBySecurityCheckFamilyType> => {
  try {
    const response =
      await instanceAxios.get<groupActionsBySecurityCheckFamilyType>(
        `projets/groupActionsBySecurityCheckFamily/${idProjet}`
      )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to Countcalculate action Progress By Source')
  }
}

export const countSecurityCheckFamilyByProjectApi = async (
  idProjet: string
): Promise<countSecurityCheckFamilyByProjectType> => {
  try {
    const response =
      await instanceAxios.get<countSecurityCheckFamilyByProjectType>(
        `projets/countSecurityCheckFamilyByProject/${idProjet}`
      )
    return response.data
  } catch (error) {
    throw new Error('Failed to count Security CheckFamily ByProject')
  }
}
export const countActionsBySCFForProject = async (
  projectId: string
): Promise<CountActionsBySCFResponse> => {
  try {
    const response = await instanceAxios.get<CountActionsBySCFResponse>(
      `${API_URL}/countActionsBySCFForProject/${projectId}`
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch SCF counts for project.')
  }
}
